import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { resourceRequest, useResource } from '../../modules/resource/resource'
import * as dialogActions from "../../modules/common/dialog"
import Link from '../../components/common/Link'
import Prepairing from '../common/Prepairing'

const DiscountAndBenefit = () => {
  const TICKET_PRICE_DISCOUNT_IMAGE_PC = 'TICKET_PRICE_DISCOUNT_IMAGE_PC'
  const TICKET_PRICE_DISCOUNT_IMAGE_M = 'TICKET_PRICE_DISCOUNT_IMAGE_M'
  const [imagePc, errorPc] = useResource(TICKET_PRICE_DISCOUNT_IMAGE_PC)
  const [imageM, errorM] = useResource(TICKET_PRICE_DISCOUNT_IMAGE_M)
  const imagePcUrl = imagePc && imagePc.resource && imagePc.resource.value
    ? `${imagePc.resource.value}`.replace('localhost:8080', 'test.ktwiz.co.kr:17400')
    : '/v2/imgs/img_2026_ticket_discount.jpg'
  const imageMUrl = imageM && imageM.resource && imageM.resource.value
    ? `${imageM.resource.value}`.replace('localhost:8080', 'test.ktwiz.co.kr:17400')
    : '/v2/imgs/img_2026_ticket_discount.jpg'

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resourceRequest(TICKET_PRICE_DISCOUNT_IMAGE_PC))
    dispatch(resourceRequest(TICKET_PRICE_DISCOUNT_IMAGE_M))
  }, [])

  useEffect(() => {
    if (errorPc && errorPc.message) {
      dispatch(dialogActions.alertOpen(errorPc.message))
    }
    if (errorM && errorM.message) {
      dispatch(dialogActions.alertOpen(errorM.message))
    }
  }, [errorPc, errorM])

  //const isPrePage = process.env.REACT_APP_IS_PREPAIRING_PAGE
  const isPrePage = "N"

  return (
    <>

      {
        isPrePage === "Y" &&
        <Prepairing />
      }

      {
        isPrePage === "N" &&
        <>
          <div class='title'>
            <h6>
              할인
          <strong class='red'>할인 및 우대된 가격으로 kt wiz 경기장에서 직접 만나 보세요!</strong>
            </h6>
          </div>
          {/* <article class='arti'>
            <div class='tit'>
              <h6>카드 할인</h6>
            </div>
            <div class='desc'>
              <table class='guide'>
                <tbody>
                  <tr>
                    <th>
                      <span>
                        참! 좋은 kt wiz 카드
                  </span>
                    </th>
                    <td>
                      <p>
                        전 좌석&nbsp;<strong class='red'>3,000원 할인</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        BC 카드
                  </span>
                    </th>
                    <td>
                      <p>
                        전 좌석&nbsp;<strong class='red'>1,000원 할인</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        kt 멤버십
                  </span>
                    </th>
                    <td>
                      <p>
                        응원지정석 / 스카이존 / 외야잔디자유석<br />
                        <strong class='red'>VIP 3,000원, 일반 2,000원 할인 </strong>
                        (1일 1회 / 월 2회)
                  </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        문화누리카드
                  </span>
                    </th>
                    <td>
                      <p>
                        스카이존 / 외야잔디자유석<br />
                        <strong class='red'>40% 할인 </strong>(본인확인 및 문화누리카드 제시 후 티켓 수령, 1인 최대 4매)
                  </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article>
          <article class='arti'>
            <div class='tit'>
              <h6>기타 할인</h6>
            </div>
            <div class='desc'>
              <table class='guide'>
                <tbody>
                <tr>
                    <th>
                      <span>
                        문화가 있는 날
                  </span>
                    </th>
                    <td>
                      <p>
                      응원지정석, 스카이존, 외야잔디자유석
                        <strong class='red'> 50% 할인 </strong>
                        (현장구매)
                        <br />
                        *매월 마지막주 화, 수, 목 / 공휴일 제외 <br />
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        kt wiz 어린이 회원
                  </span>
                    </th>
                    <td>
                      <p>
                      응원지정석, 중앙지정석, 스카이존 
                        <strong class='red'>2,000원 할인</strong>
                        <br />
                        외야잔디자유석
                        <strong class='red'>무료</strong>
                        (예매 불가, 현장에서 잔여좌석에 한하여 어린이회원 본인 확인 후 발권)
                        <br />
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        초등학생 이하
                  </span>
                    </th>
                    <td>
                      <p>
                        외야잔디자유석 본인<strong class='red'>50% 할인</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        미취학 아동(36개월 미만)
                  </span>
                    </th>
                    <td>
                      <p>
                      주민등록 등본 지참하여 무료입장 가능(단, 좌석은 미 제공)
                      <br />
                      * 보호자가 안고 관람하되 옆 사람에게 피해가 가지 않아야 한다는 전제가 따릅니다.
                      <br />
                      - 스카이박스 : 36개월 미만 무료입장 불가(2018년생 이후 0.5명으로 포함)
                      <br />
                      - 캠핑존 : 36개월 미만 아이 1명에 한하여 무료입장 가능(한 동 기준)
                      <br />
                  </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        휠체어석<br />
                        (장애인에 한함)
                  </span>
                    </th>
                    <td>
                      <p>
                        해당 좌석은 휠체어를 사용하는 장애인에 한하며,<br />
                        보호자 1인은 동일 금액으로 현장에서 예매된 옆 좌석(보호자석) 구매 가능<br />
                        <strong class='red'>(현장에서 휠체어 탑승 장애인 본인 인증 후 발권)</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        국가 유공자 / 복지 / 경로카드 소지자
                  </span>
                    </th>
                    <td>
                      <p>
                      응원지정석, 외야잔디자유석 본인 <strong class='red'>50% 할인</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        수원시 카톡 친구
                  </span>
                    </th>
                    <td>
                      <p>
                      스카이존 2,000원 할인 / 예매 불가, 현장에서 스카이존 잔여좌석이 있을 경우.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>
                        기회경기관람권(장애인/만70세 이상)
                  </span>
                    </th>
                    <td>
                      <p>
                        경기도 내 장애인, 만 70세 이상 : 중앙지정석 1,000원 관람 혜택
                        <br />
                        ※ 본인과 동반 1인에 한함 / <strong class='red'>예매 불가, 현장에서 중앙지정석 잔여좌석에 한함.</strong>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article> */}
          <div class='img-whole'>
            <img class='pc' src={imagePcUrl} alt='티켓 할인 안내' style={{width: '100%'}} />
            <img class='m' src={imageMUrl} alt='티켓 할인 안내' style={{width: '100%'}} />
          </div>
          <div class='buttons'>
            <Link to='/ticket/reservation' class='btn-reserve'>티켓 예매하기</Link>
          </div>
        </>
      }
    </>
  )
}

export default DiscountAndBenefit
